export const requiredPre2022TemplateColumns = {
  'Email Address': 'Email Address'
};
export const pre2022TemplateColumns = [
  'User ID',
  'Kaplan ID',
  'ASIC Authorised Representative Number',
  'First Name',
  'Last Name',
  requiredPre2022TemplateColumns['Email Address'],
  'Profile',
  'Group Description',
  'Activity ID',
  'Date of Activity',
  'Name of Activity',
  'Activity Conducted By',
  'Accreditation Number',
  'Training Requirement',
  'AQF Level',
  'Activity CPD Points',
  'TASA CPD Points',
  'Capability',
  'Professional Conduct',
  'Critical thinking	Reflective Practice',
  'Interdependence',
  'Attributes and Performance',
  'K1 - Responsible Manager (Generic Knowledge)',
  'K2 - Generic Knowledge',
  'K3 - Financial Planning',
  'K4 - Personal Taxation Issues (financial planning stream)',
  'K5 - Securities',
  'K6 - Derivatives',
  'K7 - Managed Investments',
  'K8 - Fixed Interest',
  'K9 - Foreign Exchange',
  'K10 - Superannuation',
  'K11 - Self Managed Superannuation Funds',
  'K12 - Retirement Income Streams',
  'K13 - Social Security & Aged Care',
  'K14 - Life Insurance',
  'K15 - General Insurance',
  'K16 - Estate Planning',
  'K17 - Deposit Products and Non-cash Facilities',
  'K18 - Credit & Mortgage Broking',
  'K19 - Commercial Lending',
  'K20 - Other OTC Markets',
  'K21 - Practice Management',
  'K22 - Personal Skills Development',
  'K23 - Skills',
  'K24 - Taxation (specialist stream)',
  'K25 - Ethics',
  'K26 - Margin Lending and Geared Investments',
  'K27 - Cyber Security',
  'K28 - Responsible Manager (Credit)',
  'K29 - Exchange Traded Funds (ETFs) and portfolio construction',
  'K30 - Credit Fundamentals',
  'F1 - Technical competence',
  'F2 - Client care and practice',
  'F3 - Regulatory compliance and consumer protection',
  'F4 - Professionalism and ethics',
  'F5 - General'
];

export const pre2022TemplateRows = [
  [
    '',
    '10673175',
    '',
    'First Name',
    'Last Name',
    'your.name@gmail.com',
    'CPD Training',
    '',
    'T583453',
    '18/3/19',
    'Other Training - Insurance Industry Update',
    'Asteron',
    '',
    'External Training',
    '',
    '1',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '1',
    '0'
  ]
];

export const requiredTemplateColumns = {
  Email: 'Email',
  'Completion Date': 'Completion Date'
};

export const templateColumns = [
  'No.',
  'Student ID',
  'First Name',
  'Middle Name',
  'Last Name',
  'Employee No',
  'ASIC authorised representative number',
  requiredTemplateColumns.Email,
  'Cohort(s)',
  'Professional Development Plan(s)',
  'Activity ID',
  requiredTemplateColumns['Completion Date'],
  'Completion Type',
  'Activity Name',
  'Activity Type',
  'Delivery Type',
  'Learning Type',
  'Provider Name',
  'Learning Structure',
  'AQF Level',
  'Supporting Documents',
  'Total (Hours)',
  'Technical competence',
  'Tax (Financial) Advice',
  'General',
  'Regulatory compliance and consumer protection',
  'Client care and practice',
  'Professionalism and ethics',
  'Mortgage broking',
  'Credit regulatory and compliance',
  'Credit industry developments',
  'TASA',
  'Managed Investments',
  'Foreign exchange',
  'Financial markets',
  'Consumer protection',
  'Derivatives',
  'Margin lending',
  'Gearing',
  'RG206 General (Combined)',
  'Economic environment',
  'Responsible manager',
  'Regulatory environment',
  'Securities',
  'Compliance',
  'Skills',
  'Client engagement',
  'Generic knowledge',
  'Technology',
  'Practice Management',
  'Deposit products and non-cash facilities',
  'General Insurance',
  'Industry trends',
  'Life Insurance',
  'Retirement',
  'Professional standards',
  'Financial planning',
  'Tax',
  'Superannuation',
  'Estate planning',
  'Behavioural finance',
  'Aged care',
  'Social security',
  'Fixed Interest',
  'Self Managed Superannuation Funds',
  'Business banking',
  'Property',
  'Commodities',
  'The SMSF Association (SMSFA)',
  'The SMSF Association (SMSFA) Hours',
  'Certified Practising Accountant (CPA)',
  'Certified Practising Accountant (CPA) Hours',
  'Financial Planning Association (FPA)',
  'Financial Planning Association (FPA) Hours',
  'Association of Financial Advisers (AFA)',
  'Association of Financial Advisers (AFA) Hours',
  'Finance Brokers Association of Australia (FBAA)',
  'Finance Brokers Association of Australia (FBAA) Hours',
  'Kaplan Education',
  'Kaplan Education Hours',
  'Employer',
  'Employer Hours',
  'Other',
  'Other Hours',
  'The Stockbrokers and Investment Advisers Association (SIAA)',
  'The Stockbrokers and Investment Advisers Association (SIAA) Hours'
];



// WEBPACK FOOTER //
// ./src/constants/kaplan-template.js